import { OmniaApiState } from "../../api/apiState"
import { defineDirective } from "../../utils/angular"

/** @internal */
export class ButtonCtrl {


    static create() {
        return defineDirective(ButtonCtrl, "shared/main/notifications/button.html", {})
    }

    public unreadEventsCount = 0
    public showEvents = false

    public activeSessionsCount = 0
    public showUsers = false


    static $inject = ["$scope", "OmniaApiState"]

    constructor(
        private readonly $scope: ng.IScope,
        private readonly apiState: OmniaApiState,
    ) {

    }

    $onInit() {
        this.$scope.$watchGroup(["vm.apiState.sessions", "vm.apiState.events"], () => this.refresh())
    }

    private refresh() {
        const { sessions, events } = this.apiState
        this.unreadEventsCount = events.unread.length
        this.showEvents = this.unreadEventsCount > 0
        this.activeSessionsCount = sessions.active.length
        this.showUsers = this.activeSessionsCount > 1
    }

}
